export const initValues = {vacationType:null, daysLimit:null, unusedDaysFromPreviousYear:null}